import React, {Component} from "react";
import {request} from "../../../api-client";
import {makeFitImageUrlWithSize, setStatePromise} from "../../../utils";
import PropTypes from "prop-types";
import browserHistory from "../../../utils/browserHistory";
import localization from "../../../config/localization";
import GlobalAddToPlaylistDialog from "../../../components/Letflow/AddToPlaylistDialog/GlobalAddToPlaylistDialog";
import {
  addHttpsToUrl,
  checkIfMobile, GAevent,
  homePathGenerator,
  setPageTitle
} from "../../../api-client/core/authentication/utils";
import ShareDialog from "../../../components/Letflow/ShareDialog";
import {makeImageUrlWithSize, makeThumbnailUrlWithSize} from "../HomeElements/utils";
import ContentCreatorBackground from "../../../assets/img/Letflow/content_creator_background.png";
import ProfilePicture from "../../../assets/img/default-avatar.png"
import {Dialog, IconButton} from "@material-ui/core";
import Contact from "../Contact/index.jsx"
import { CloudDownload} from "@material-ui/icons";
import {Link} from "react-router-dom";
import contentCreator from "../../../api-client/core/public/contentCreator";
import AudiovisualCreator from "./AudiovisualCreator";
import EditorialCreator from "./EditorialCreator";
import {get} from "lodash";
import queryString from "qs";

export default class ContentCreator extends Component {
  constructor(props) {
    super(props)
    this.myRef = React.createRef()
  }

  state = {
    contentCreator: null,
    contentCreations: [],
    selectedContentCreation: null,
    favorite: false,
    tags: [],
    autoPlay: false,
    key: 0,
    currentIndex: 0,
    showContactDialog: false,
    height: "175px",
    loaded: false,
    fullContent: false,
    failedLink: false
  };

  componentDidMount = () => {
    this.fetchContentCreator().then(() => this.state.contentCreations.length < 1 && this.setState({height: '100%'}));
    if (!this.props.modal) {
      window.scrollTo(0, 0);
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.contentCreatorId !== prevProps.contentCreatorId) {
      this.setState({loaded: false}, () => {
        this.fetchContentCreator().then(() => this.state.contentCreations.length < 1 && this.setState({height: '100%'}));
      })
    }
  }

  fetchContentCreator = () => {
    let queryParams = queryString.parse(window.location.search)
    let allCreations = false;
    if (queryParams['?allCreations']) {
      allCreations = true
    }
    let newRequest =
      this.props.preview ? request.contentCreator.preview(this.props.contentCreatorId, `include=type;image;coverImage;contentCreations.favorite;contentCreations.video.thumbnail;contentCreations.image;contentCreations.closedCaptions.binary;contentCreations.audio.waveform;contentCreations.tags;contentCreations.binary;favorite;country;residence;socialLinks;downloadableMaterial.audio;downloadableMaterial.video;downloadableMaterial.image;downloadableMaterial.binary;contentCreations.embededContent${allCreations ? "&allCreations=true" : ""}`)
        : this.props.isPublic ? (!this.props.contentCreatorAlias ? request.contentCreator.getPublic(this.props.contentCreatorId, `include=type;image;coverImage;contentCreations.favorite;contentCreations.video.thumbnail;contentCreations.image;contentCreations.closedCaptions.binary;contentCreations.audio.waveform;contentCreations.binary;contentCreations.tags;favorite;country;residence;socialLinks;downloadableMaterial.audio;downloadableMaterial.video;downloadableMaterial.image;downloadableMaterial.binary;contentCreations.embededContent`) :
            request.contentCreator.getPublicByAlias(this.props.contentCreatorAlias, `include=type;image;coverImage;contentCreations.favorite;contentCreations.video.thumbnail;contentCreations.image;contentCreations.closedCaptions.binary;contentCreations.audio.waveform;contentCreations.binary;contentCreations.tags;favorite;country;residence;socialLinks;downloadableMaterial.audio;downloadableMaterial.video;downloadableMaterial.image;downloadableMaterial.binary;contentCreations.embededContent`)) :
              request.contentCreator.showForHome(this.props.contentCreatorId, `include=type;image;coverImage;contentCreations.favorite;contentCreations.video.thumbnail;contentCreations.image;contentCreations.closedCaptions.binary;contentCreations.audio.waveform;contentCreations.binary;contentCreations.tags;favorite;country;residence;socialLinks;downloadableMaterial.audio;downloadableMaterial.video;downloadableMaterial.image;downloadableMaterial.binary;contentCreations.embededContent`)

    return newRequest.then(data => {
      setPageTitle(`${data.name}`)
      let creatorData = {
        id: data.id,
        name: data.name,
        email: data.email,
        description: data.description,
        coverImageUrl: data.coverImage ? makeImageUrlWithSize({image: data.coverImage}, 'lg') : (data.image ? makeImageUrlWithSize(data, 'lg') : data.type.type === 'audiovisual' ? ContentCreatorBackground : null),
        imageUrl: data.image ? makeFitImageUrlWithSize(data, 'sm') : ProfilePicture,
        image: data.image,
        country: data.country,
        residence: data.residence,
        brand: data.brand,
        type: data.type,
        socialLinks: data.socialLinks,
        downloadableMaterial: data.downloadableMaterial,
        activityStart: data.activity_start || data.created_at,
        tags: data.tags || [],
        hashcode: data.hashcode,
      };
      const contentCreations = data.contentCreations.map((contentCreation, key) => ({
        id: contentCreation.id,
        title: contentCreation.title,
        subtitle: contentCreation.subtitle || '',
        description: contentCreation.description,
        audioUrl: contentCreation.audio && contentCreation.audio.url,
        audio: contentCreation.audio &&
          {
            ...contentCreation.audio,
            title: contentCreation.audio.original_name,
          },
        has_pre_roll: get(contentCreation, 'has_pre_roll', false),
        video: contentCreation.video,
        url: contentCreation.video && contentCreation.video.url,
        smallUrl: contentCreation.video && contentCreation.video.url + '#t=2',
        smallImageUrl: contentCreation.image ? makeImageUrlWithSize(contentCreation, 'md-16:9') : null,
        imageUrl: contentCreation.image ? makeFitImageUrlWithSize(contentCreation, 'lg') : null,
        imageId: contentCreation.image ? contentCreation.image.id : null,
        thumbnail: contentCreation.video && makeThumbnailUrlWithSize(contentCreation.video, 'md-16:9'),
        binary: contentCreation.binary ? contentCreation.binary : "",
        link: contentCreation.link ? contentCreation.link : "",
        height: contentCreation.image ? contentCreation.image.height : (contentCreation.video ? contentCreation.video.height : null),
        width: contentCreation.image ? contentCreation.image.width : (contentCreation.video ? contentCreation.video.width : null),
        tags: contentCreation.tags || [],
        subtitles: contentCreation.closedCaptions || null,
        embededContent: contentCreation.embededContent || null,
        downloadable: contentCreation.downloadable,
        requireDrm: contentCreation.require_drm,
        viewed: false,
        views: contentCreation.views,
        image: contentCreation.image,
        favorite: contentCreation.favorite || false,
        key,
        contentCreator: creatorData
      }));
      setStatePromise(this, {
        contentCreator: creatorData,
        containerType: data.type.type,
        views: data.views,
        favorite: data.favorite,
        contentCreations,
        tags: this.getTagsFromContentCreations(data.contentCreations),
        selectedContentCreation: contentCreations[0],
      })
    })
      .then(this.filterContentCreationsBySelectedTags)
      .then(() => {
        this.state.contentCreator.coverImageUrl &&
        this.setState({
          contentCreator: {
            ...this.state.contentCreator,
          }
        }, () => GAevent('Contenido', "Visualizar", this.state.contentCreator.name))
      })
      .then(() => {
        this.setState({loaded: true})
      })
      .catch((res) => {
        console.log('catch', res)
        if (res.status === 403) {
          this.setState({notAvailable: true})
        } else if (this.props.isPublic) {
          this.setState({failedLink: true})
        }else {
          if (!this.props.modal) {
            browserHistory.push(homePathGenerator(''))
          } else {
            this.props.onModalClose()
          }
        }
      });
  };

  getTagsFromContentCreations = (contentCreations) => {
    let tags = [];
    contentCreations.forEach(contentCreation => {
      contentCreation.tags.forEach(tag => {
        !tags.find(t => t.id === tag.id) && tags.push(tag)
      })
    });
    return tags.sort((a, b) => a.name.localeCompare(b.name));
  };

  toggleFavorite = () => {
    this.setState({favorite: !this.state.favorite}, () => {
      GAevent('Contenido', "Favorite", this.state.contentCreator.name)
      request.contentCreatorFavorite[this.state.favorite ? 'add' : 'remove'](this.state.contentCreator.id)
    })
    this.props.modal && this.props.toggleModalFavorite && this.props.toggleModalFavorite()
  };

  onSelectedTagChanged = selectedTag => {
    this.setState({
      tags: this.updateTagGroups(this.state.tags, selectedTag),
      lastTagSelected: selectedTag
    }, () => this.filterContentCreationsBySelectedTags())
  }

  updateTagGroups = (tags, selectedTag) => {
    return tags.map(tag => ({
      ...tag,
      state: (
        selectedTag &&
        (selectedTag !== this.state.lastTagSelected || (tag.state === 'selected' && selectedTag === this.state.lastTagSelected)) &&
        selectedTag.toString() === tag.id.toString()
      ) ? 'selected' : 'available'
    }))
  }

  filterContentCreationsBySelectedTags = () => {
    let {contentCreations} = this.state;

    let selectedTag = this.state.tags.find(tag => tag.state === 'selected');

    let contentCreationsBySelectedTags = contentCreations
      .filter(contentCreation => contentCreation.audio ||
        get(contentCreation, 'link', false) ||
        get(contentCreation, 'binary', false) ||
        get(contentCreation, 'imageUrl', false) ||
        get(contentCreation, 'video.url', false) ||
        get(contentCreation, 'video.dash', false) ||
        get(contentCreation, 'embededContent', null) ||
        get(contentCreation, 'video.hls', false)
      );

    if (selectedTag) {
      const filterTags = contentCreation => contentCreation.tags.some(tag => tag.id === selectedTag.id);

      contentCreationsBySelectedTags = contentCreationsBySelectedTags.filter(filterTags);
    }

    this.setState({contentCreationsBySelectedTags});
  }

  handleAddToPlaylistButtonPress = (data, type) => {
    GlobalAddToPlaylistDialog.show({
      type: type,
      contentCreatorType: type === 'contentCreator' && data.type.slug,
      selectedTrack: data,
      contentCreatorTagsIds: type === 'contentCreator' && this.getTagsFromContentCreations(this.state.contentCreations).map(tag => tag.id)
    });
  };

  renderShareDialog = () => {
    return (
      <ShareDialog
        show={this.state.showShareDialog}
        handleClose={() => this.setState({showShareDialog: false})}
        entity={'contentCreator'}
        id={this.props.contentCreatorId}
      />
    )
  };

  renderContactDialog = () =>
    <Dialog open={this.state.showContactDialog} onBackdropClick={() => this.setState({showContactDialog: false})}
            maxWidth="false">
      <div style={{width: !checkIfMobile() ? 700 : "75vw"}}>
        <Contact
          modal={true}
          onSubmit={(name, email, description) => request.contentCreator.contact(this.props.contentCreatorId, name, email, description)}
          afterSubmit={() => this.setState({showContactDialog: false})}/>
      </div>
    </Dialog>

  makeWorkContainerTitle = (downloadableMaterial) => {
    if (downloadableMaterial) {
      return (
        <div>
          {downloadableMaterial.link ?
            <Link to={addHttpsToUrl(downloadableMaterial.link)} target="_blank">
              <span style={{color: "#fff"}}>{downloadableMaterial.name}</span>
            </Link>
            :
            <>
              <span>{downloadableMaterial.name}</span>
              <IconButton
                style={{marginLeft: 5, color: 'white'}}
                title={localization.get('download')}
                onClick={() => {
                  GAevent('Contenido', "Descargar", this.state.contentCreator.name)
                  window.open(
                    downloadableMaterial.type === 'image' ? request.contentCreator.downloadMaterial(downloadableMaterial.id)
                      : downloadableMaterial[downloadableMaterial.type !== 'other' ? downloadableMaterial.type : 'binary'].url
                    , "_blank")
                }}
              >
                <CloudDownload/>
              </IconButton>
            </>
          }
        </div>
      )
    }
  }

  //scroll = ()  => window.scrollTo(0, this.myRef.current.offsetTop + 175)
  scroll = () => document.getElementById('reference-scroll-position').scrollIntoView({
    block: "start",
    behavior: "smooth",
  })

  render = () => {
    let {loaded, contentCreator, contentCreations} = this.state;

    if (this.state.failedLink) {
      return (
        <div style={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          height: "100%",
          minHeight: "80vh",
          background: "white",
          width: "90%",
          borderRadius: "1%",
          margin: "0 5%",
          marginTop: "90px",
        }}>
          <p style={{fontSize: 30}}>{localization.get('error.expired_link')}</p>
        </div>)
    }

    if (!loaded) {
      return (<></>)
    }

    if (this.state.containerType === 'talent' || this.state.containerType === 'audiovisual') {
      return (
        <AudiovisualCreator
          {...this.props}
          contentCreator={contentCreator}
          contentCreations={contentCreations}
          favorite={this.state.favorite}
          tags={this.state.tags}
          selectedContentCreation={this.state.selectedContentCreation}
          contentCreationsBySelectedTags={this.state.contentCreationsBySelectedTags}
          preview={this.props.preview}
          reloadContentCreator={this.fetchContentCreator}
          isPublic={this.props.isPublic}
        />
      );
    }

    if (this.state.containerType === 'editorial') {
      return (
        <>
          <EditorialCreator
            {...this.props}
            contentCreator={contentCreator}
            favorite={this.state.favorite}
          />
        </>
      )
    }

  };
}

ContentCreator.propTypes = {
  contentCreatorId: PropTypes.number.isRequired
};